import React, { useState, useEffect } from "react";
import { authService } from "../services/auth";
import { useAuth } from "../contexts/AuthContext";

const UserRoleDebug = () => {
  const { user } = useAuth();
  const [currentRole, setCurrentRole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchRole = async () => {
      if (user) {
        const role = await authService.getCurrentUserRole();
        setCurrentRole(role);
      }
    };
    fetchRole();
  }, [user]);

  const handleRefreshRole = async () => {
    setLoading(true);
    try {
      const role = await authService.getCurrentUserRole();
      setCurrentRole(role);
      setMessage("Role atualizada!");
    } catch (error) {
      setMessage("Erro ao buscar role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <div>Carregando usuário...</div>;
  }

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6">Debug de Role de Usuário</h2>
      
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="mb-4">
          <strong>Email do Usuário:</strong> {user.email}
        </div>
        
        <div className="mb-4">
          <strong>ID do Usuário:</strong> {user.id}
        </div>
        
        <div className="mb-4">
          <strong>Role Atual:</strong> {currentRole || "Carregando..."}
        </div>
        
        <div className="mb-4">
          <strong>App Metadata (fonte de autorização):</strong>
          <pre className="bg-gray-100 p-3 rounded mt-2 text-sm">
            {JSON.stringify(user.app_metadata, null, 2)}
          </pre>
        </div>

        <div className="mb-4">
          <strong>User Metadata (informativo — não usado para autorização):</strong>
          <pre className="bg-gray-100 p-3 rounded mt-2 text-sm">
            {JSON.stringify(user.user_metadata, null, 2)}
          </pre>
        </div>

        <div className="space-x-4">
          <button
            onClick={handleRefreshRole}
            disabled={loading}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            {loading ? "Carregando..." : "Atualizar Role"}
          </button>
        </div>
        
        {message && (
          <div className="mt-4 p-3 bg-blue-100 border border-blue-400 text-blue-700 rounded">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserRoleDebug;